import React, {useEffect}from 'react';
import { Autoplay, Controller, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import NewsBlock from '../../components/ConsultancyElements/NewsBlock';
import SectionTitle from '../../components/ConsultancyElements/SectionTitle';
import BlogService from  '../../services/BlogService';

const NewsContainer = () => {
        const [blogs, setBlogs] = React.useState([]);
        console.log("blgos state values in home ... ", blogs);
        useEffect(() => {
            fetchBlogs();
        }, [])
        
        const fetchBlogs = async () => {
           try {
             const response = await BlogService.getBlogList();
             console.log("blogs fetched successfully home... s", response);
             const filterdBlogs = response?.data?.filter(blog => blog?.isPublished === true);
             setBlogs(filterdBlogs || []);
           } catch (error) {
            console.log("error occured while fetching blogs", error);
           }
        }
    const NewsData = [
        {
            id: '1',
            img: 'images/blog/1.jpg',
            authorImg: 'images/blog/author-3.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Rayan Kellar'
        },
        {
            id: '2',
            img: 'images/blog/2.jpg',
            authorImg: 'images/blog/author-4.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Mellisa Obrian'
        },
        {
            id: '3',
            img: 'images/blog/3.jpg',
            authorImg: 'images/blog/author-5.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Jessica Ballinger'
        },
        {
            id: '4',
            img: 'images/blog/1.jpg',
            authorImg: 'images/blog/author-3.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Rayan Kellar'
        },
        {
            id: '5',
            img: 'images/blog/2.jpg',
            authorImg: 'images/blog/author-4.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Mellisa Obrian'
        },
        {
            id: '6',
            img: 'images/blog/3.jpg',
            authorImg: 'images/blog/author-5.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Jessica Ballinger'
        },
        {
            id: '7',
            img: 'images/blog/1.jpg',
            authorImg: 'images/blog/author-3.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Rayan Kellar'
        },
        {
            id: '8',
            img: 'images/blog/2.jpg',
            authorImg: 'images/blog/author-4.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Mellisa Obrian'
        },
        {
            id: '9',
            img: 'images/blog/3.jpg',
            authorImg: 'images/blog/author-5.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Jessica Ballinger'
        },
        {
            id: '10',
            img: 'images/blog/1.jpg',
            authorImg: 'images/blog/author-3.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Rayan Kellar'
        },
        {
            id: '11',
            img: 'images/blog/2.jpg',
            authorImg: 'images/blog/author-4.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Mellisa Obrian'
        },
        {
            id: '12',
            img: 'images/blog/3.jpg',
            authorImg: 'images/blog/author-5.jpg',
            tag: 'Consultant',
            date: 'January 11, 2026',
            author: 'Jessica Ballinger'
        },
    ];

    return (
        <section className="news-section">
            <div className="container">
                <SectionTitle
                    title='Latest News'
                    header='Read Our Latest News'
                />

                <div className="news-carousel owl-carousel owl-theme">

                <Swiper
    modules={[Navigation, Controller, Autoplay]}
    autoplay={{ delay: 5000 }}
    spaceBetween={15} // 15px gap on mobile
    slidesPerView={1.2} // Shows a peek of the next card on mobile
    centeredSlides={true}
    breakpoints={{
        768: {
            slidesPerView: 2,
            spaceBetween: 30, // 30px gap on tablets
            centeredSlides: false,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30, // 40px gap on desktops
            centeredSlides: false,
        },
    }}
    navigation={{
        prevEl: '.owl-prev',
        nextEl: '.owl-next',
    }}
>
    {blogs.map(data => (
        <SwiperSlide key={data.id}>
            <NewsBlock data={data} index={'homePage'} />
        </SwiperSlide>
    ))}
</Swiper>

                    {/* <div className="owl-nav">
                        <div className="owl-prev">
                            <span className="fa fa-angle-left"></span>
                        </div>
                        <div className="owl-next">
                            <span className="fa fa-angle-right"></span>
                        </div>
                    </div> */}

                </div>
            </div>
        </section>
    );
};

export default NewsContainer;